import { useState } from 'react';
import styled from 'styled-components';
import { Icon } from '../../../../../components/common/icon/Icon';
import { RadioCircle } from '../../../../../components/common/inputs/RadioCircle';
import { SlideConfirmModal } from '../../../../../components/common/modal/slide/SlideConfirmModal';
import { ampli } from '../../../../../ampli';

const JEONBUK_CITIES = [
  '전체',
  '전주시',
  '군산시',
  '익산시',
  '정읍시',
  '남원시',
  '김제시',
  '완주군',
  '진안군',
  '무주군',
  '장수군',
  '임실군',
  '순창군',
  '고창군',
  '부안군',
];

const JEONNAM_CITIES = [
  '전체',
  '목포시',
  '여수시',
  '순천시',
  '나주시',
  '광양시',
  '담양군',
  '곡성군',
  '구례군',
  '고흥군',
  '보성군',
  '화순군',
  '장흥군',
  '강진군',
  '해남군',
  '영암군',
  '무안군',
  '함평군',
  '영광군',
  '장성군',
  '신안군',
];

const GYEONGBUK_CITIES = [
  '전체',
  '포항시',
  '경주시',
  '김천시',
  '안동시',
  '구미시',
  '영주시',
  '영천시',
  '상주시',
  '문경시',
  '경산시',
  '의성군',
  '청송군',
  '영양군',
  '영덕군',
  '청도군',
  '고령군',
  '성주군',
  '칠곡군',
  '예천군',
  '봉화군',
  '울진군',
  '울릉군',
];

const STATES = ['전국', '전북특별자치도', '전라남도', '경상북도'];

interface SubsidyRegionFilterProps {
  selectedState: string;
  selectedCity: string;
  onStateChange: (state: string) => void;
  onCityChange: (city: string) => void;
}

export const SubsidyRegionFilter = ({
  selectedState,
  selectedCity,
  onStateChange,
  onCityChange,
}: SubsidyRegionFilterProps) => {
  const [isStateModalOpen, setIsStateModalOpen] = useState(false);
  const [isCityModalOpen, setIsCityModalOpen] = useState(false);

  const getCurrentCities = () => {
    if (selectedState === '전북특별자치도') return JEONBUK_CITIES;
    if (selectedState === '전라남도') return JEONNAM_CITIES;
    if (selectedState === '경상북도') return GYEONGBUK_CITIES;
    return ['전체'];
  };

  return (
    <>
      <FilterContainer>
        <FilterButton onClick={() => setIsStateModalOpen(true)}>
          <FilterButtonText>{selectedState}</FilterButtonText>
          <Icon name={'AngleDown'} width={12} height={12} fill={'#858894'} />
        </FilterButton>
        <FilterButton onClick={() => setIsCityModalOpen(true)}>
          <FilterButtonText>{selectedCity === '전체' ? '시 · 군' : selectedCity}</FilterButtonText>
          <Icon name={'AngleDown'} width={12} height={12} fill={'#858894'} />
        </FilterButton>
      </FilterContainer>

      {/* State Selection Modal */}
      <SlideConfirmModal
        isShow={isStateModalOpen}
        closeButton={{ handleClick: () => setIsStateModalOpen(false) }}
        isShowCloseButton
        element={
          <OptionList>
            {STATES.map((state) => (
              <OptionItem
                key={state}
                onClick={() => {
                  onStateChange(state);
                  setIsStateModalOpen(false);
                  ampli.pvmClickSubsidyLocationFilter({
                    state,
                    city: selectedCity,
                  });
                }}
              >
                <RadioCircle isSelected={selectedState === state} />
                <OptionText>{state}</OptionText>
              </OptionItem>
            ))}
          </OptionList>
        }
      />

      {/* City Selection Modal */}
      <SlideConfirmModal
        isShow={isCityModalOpen}
        closeButton={{ handleClick: () => setIsCityModalOpen(false) }}
        isShowCloseButton
        height={600}
        element={
          <OptionList>
            {getCurrentCities().map((city) => (
              <OptionItem
                key={city}
                onClick={() => {
                  onCityChange(city);
                  setIsCityModalOpen(false);
                  ampli.pvmClickSubsidyLocationFilter({
                    state: selectedState,
                    city,
                  });
                }}
              >
                <RadioCircle isSelected={selectedCity === city} />
                <OptionText>{city}</OptionText>
              </OptionItem>
            ))}
          </OptionList>
        }
      />
    </>
  );
};

const FilterContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 24px;
`;

const FilterButton = styled.button`
  display: flex;
  padding: 10px 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;

  border-radius: 100px;
  background: #f2f2f7;
  border: none;
  cursor: pointer;

  &:active {
    background: #e5e5ea;
  }
`;

const FilterButtonText = styled.span`
  color: #505363;
  font-family: Pretendard;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

const OptionList = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 8px 0;
  max-height: 500px;
  overflow-y: auto;
`;

const OptionItem = styled.div`
  display: flex;
  align-items: center;
  padding: 14px 24px;
  gap: 12px;
  cursor: pointer;

  &:active {
    background: #f8f8fa;
  }
`;

const OptionText = styled.span`
  color: #232429;
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;
